<template>
  <div class="file-upload">
    <el-upload
        :action="baseURL + '/upload'"
        :headers="{token: token}"
        :accept="accept"
        :on-remove="deleteFile"
        :on-change="uploadFile"
        :file-list="fileList">
      <el-button size="small" type="primary"  icon="el-icon-upload">点击上传</el-button>
    </el-upload>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    },
    accept: {
      type: String,
      default () {
        return '.pdf'
      }
    }
  },
  name: 'FileUpload',
  data () {
    return {
      baseURL: this.baseUrl,
      token: localStorage.getItem('token'),
      fileList: this.list,
      videoSrc: '',
      visible: false
    }
  },
  watch: {
    list (newV) {
      this.fileList = newV
    }
  },
  methods: {
    uploadFile (file) {
      if (file.response && file.response.code === '200') {
        this.$message.success('上传成功')
        this.fileList.push({url: file.response.msg, name: file.response.msg})
        this.$emit('success', this.fileList)
      }
    },
    // 上传之前的操作
    beforeUpload (file) {
      const isLt20M = file.size / 1024 / 1024 < 20
      if (!isLt20M) {
        this.$message.error('上传文件大小不能超过 20MB!')
      }
      return isLt20M
    },
    // 删除视频
    deleteFile (file) {
      if (file.status === 'success') {
        this.fileList.forEach((item, index) => {
          if (item.url === file.url) {
            this.fileList.splice(index, 1)
            this.$emit('success', this.fileList)
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.file-upload {
  width: calc(100% - 56px);
}
.play-btn {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/fileUpload.vue